import { isUndefined, isNull, isObject, isEmpty, isString, lowerCase, get, trim, isNumber, replace, some } from 'lodash';
export function empty(obj) {
  if (isUndefined(obj) || isNull(obj)) {
    return true;
  }
  if (isObject(obj)) {
    return isEmpty(obj);
  }
  return trim(obj) === '';
}
export function slugData(data, separator) {
  if (isString(data)) {
    let slug = lowerCase(data);
    // convert to english type
    slug = slug.replace(/á|à|ả|ạ|ã|ă|ắ|ằ|ẳ|ẵ|ặ|â|ấ|ầ|ẩ|ẫ|ậ/gi, 'a');
    slug = slug.replace(/é|è|ẻ|ẽ|ẹ|ê|ế|ề|ể|ễ|ệ/gi, 'e');
    slug = slug.replace(/i|í|ì|ỉ|ĩ|ị/gi, 'i');
    slug = slug.replace(/ó|ò|ỏ|õ|ọ|ô|ố|ồ|ổ|ỗ|ộ|ơ|ớ|ờ|ở|ỡ|ợ/gi, 'o');
    slug = slug.replace(/ú|ù|ủ|ũ|ụ|ư|ứ|ừ|ử|ữ|ự/gi, 'u');
    slug = slug.replace(/ý|ỳ|ỷ|ỹ|ỵ/gi, 'y');
    slug = slug.replace(/đ/gi, 'd');
    if (isString(separator)) {
      slug = slug.replace(/[^a-zA-Z0-9]/gi, separator);
    } else {
      slug = slug.replace(/[^a-zA-Z0-9]/gi, '');
    }
    return slug;
  }
  return data;
}

export function getVal(object, key, defaultValue) {
  const data = get(object, key);
  if (empty(data)) {
    return defaultValue;
  }
  return data;
}

export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function separateNumber(d, s) {
  /* eslint-disable no-param-reassign */
  if (!isString(d) && !isNumber(d)) {
    return 0;
  }
  if (!isString(s)) {
    s = ',';
  }
  d = replace(d.toString(), s);
  while (/(\d+)(\d{3})/.test(d.toString())) {
    d = d.toString().replace(/(\d+)(\d{3})/, `$1${s}$2`);
  }
  return d;
  /* eslint-enable */
}

export function insertJs(s, srcArrInput, cb = () => {}) {
  const srcArr = srcArrInput.filter(item => !empty(item));
  const d = window.document;
  const c = Array.prototype.slice.call(d.head.getElementsByTagName(s));

  if (srcArr.length === 0) {
    cb();
  } else {
    const src = srcArr[0];
    const id = getFileName(src);
    if (!some(c, item => item.id === id)) {
      const curTime = new Date().getTime();
      const js = d.createElement(s);
      const fjs = c[c.length - 1];
      js.id = id;
      if (s === 'link') {
        js.href = src + '?ts=' + curTime;
        js.rel = 'stylesheet';
      } else if (s === 'script') {
        js.src = src + '?ts=' + curTime;
      }
      fjs.parentNode.insertBefore(js, fjs.nextSibling);
      js.onload = () => {
        srcArrInput.shift();
        insertJs(s, srcArrInput, cb);
      };
    } else {
      srcArrInput.shift();
      insertJs(s, srcArrInput, cb);
    }
  }
}

export function getFileName(path) {
  var fileName = '';
  // eslint-disable-next-line no-useless-escape
  var patt = /\/([^\\\/:*\"<>|]+)$/g;
  var n = patt.exec(path);
  if (n !== null) {
    fileName = n[1];
  }
  return fileName;
}

export function checkValidVideoUrl(url) {
  if (!url) {
    return false;
  }

  const matched = url.match(/^(http:\/\/|https:\/\/)((player\.)?vimeo\.com|youtu\.be|(www\.)?youtube\.com)\/([\w/]+)([?].*)?$/gi);
  if (matched) {
    return true;
  } else {
    return false;
  }
}

export function checkValidSlug(slug) {
  if (!slug) {
    return false;
  }

  const matched = slug.match(/^[a-z0-9]+(?:-[a-z0-9]+)*$/g);
  if (matched) {
    return true;
  } else {
    return false;
  }
}

export function capitalize(str) {
  if (!str) {
    return str;
  }

  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function convertVideoToEmbed(videoUrl) {
  if (!videoUrl) {
    return videoUrl;
  }

  const vimeoPattern = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g;
  const vimeoPlayerPattern = /player\.vimeo\.com/g;
  const youtubePattern = /(?:http?s?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?(.+)/g;

  if (vimeoPattern.test(videoUrl) && !vimeoPlayerPattern.test(videoUrl)) {
    return videoUrl.replace(vimeoPattern, 'https://player.vimeo.com/video/$1');
  }

  if (youtubePattern.test(videoUrl)) {
    return videoUrl.replace(youtubePattern, 'https://www.youtube.com/embed/$1');
  }

  return videoUrl;
}

// https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
export function iOS() {
  return (
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.userAgent.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
}

// https://stackoverflow.com/questions/8348139/detect-ios-version-less-than-5-with-javascript
export function iOSversion() {
  if (/iP(hone|od|ad)/.test(navigator.platform)) {
    // supports iOS 2.0 and later
    var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
  }
}
